import courseConfigDev from './courseConfigDev';
import courseConfigProd from './courseConfigProd';

export default process.env.REACT_APP_ENV === 'test' ? courseConfigDev : courseConfigProd;
